module.exports = __webpack_public_path__ + "img/baeeb7d.jpg";